const DEFAULT_TIME = "18:05:00";

/** First day of fx_minute_quotes history: 1 June 2026 00:00 UTC. */
export const BESTX_EARLIEST_EXECUTION_MS = Date.UTC(2026, 5, 1);
export const BESTX_EXECUTION_RANGE_ERROR =
  "Completion time must be on or after 1 June 2026 and cannot be in the future.";

const pad = (value: number) => String(value).padStart(2, "0");

const formatDateTime = (date: Date, time = DEFAULT_TIME) => {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )} ${time}`;
};

const formatDate = (date: Date) => {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}`;
};

const getBaseTradeDate = () => {
  const today = new Date();
  const baseDate = new Date(today);
  const day = baseDate.getDay();

  if (day === 6) {
    baseDate.setDate(baseDate.getDate() - 1);
    return baseDate;
  }

  if (day === 0) {
    baseDate.setDate(baseDate.getDate() - 2);
    return baseDate;
  }

  baseDate.setDate(baseDate.getDate() - 5);
  return baseDate;
};

export const getDefaultBestXExecutionTimestamp = () => {
  return formatDateTime(getBaseTradeDate());
};

export const getDefaultBestXExpiryTimestamp = () => {
  const expiryDate = new Date(getBaseTradeDate());
  expiryDate.setMonth(expiryDate.getMonth() + 1);
  return formatDate(expiryDate);
};
